export { default } from './MultiPrice';
